import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { useGameContracts } from "@seabrookstudios/pitch2table";
import { formatContractDescription } from "@seabrookstudios/pitch2table-core";

const Label = "Contract";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {import("@seabrookstudios/pitch2table-core").AttachmentId|"unset"} props.value
 * @param {(value: import("@seabrookstudios/pitch2table-core").AttachmentId|"unset") => void} props.onChange
 * @param {React.ReactNode} props.helperText
 * @param {boolean} [props.disabled]
 * @param {import("@seabrookstudios/pitch2table-core").ContractType[]} [props.allowTypes]
 * @param {string} [props.label]
 */
export const ContractSelect = ({
  gameId,
  value,
  onChange,
  helperText,
  disabled = false,
  allowTypes = [],
  label = Label,
}) => {
  const { data: contracts = [], isLoading } = useGameContracts(gameId);

  /**
   * @param {*} ev
   */
  const onChangeHandler = (ev) => {
    onChange(ev.target.value);
  };

  return (
    <FormControl sx={{ width: "100%" }} margin="normal" disabled={disabled}>
      <InputLabel id="contract">{label}</InputLabel>
      <Select
        labelId="contract"
        value={value}
        onChange={onChangeHandler}
        label={label}
        input={<OutlinedInput label={label} />}
      >
        <MenuItem key="none" value={"unset"}>
          None
        </MenuItem>
        {isLoading ? (
          <CircularProgress />
        ) : (
          contracts
            .filter((contract) => allowTypes.includes(contract.type))
            .map((contract) => (
              <MenuItem key={contract.id} value={contract.id}>
                {formatContractDescription(contract)}
              </MenuItem>
            ))
        )}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};
